import React from 'react';

import useFormCtx from './useFormCtx';

module.exports = (Component) => (
  {
    className,
    ...props
  }
) => {
  const {
    id,
    label,
    name,
    value,
    showError,
    onChange,
    disabled
  } = useFormCtx(props);

  return (
    <Component
      className={className}
      label={label}
      checkboxProps={{
        id,
        value,
        name,
        onChange,
        disabled,
        showError
      }}
    />
  );
}
